<template>
  <div id="container">
    <div style="height:43px;">
      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="handleAddRole()"
        style="position: relative;left: 7px;"
        v-if="ifCheck"
      >新增</el-button>

      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="showQueryDialog = true"
        style="float:right"
      >查询</el-button>
    </div>

    <!-- 精准查询框 -->
    <el-dialog
      width="80%"
      :visible.sync="showQueryDialog"
      title="搜索"
      @close="showQueryDialog = false"
    >
      <el-form :model="item" label-position="right" :rules="rules">
        <el-form-item label="所属">
          <el-radio-group v-model="item.belong">
            <el-radio-button :label="1">我的单位</el-radio-button>
            <el-radio-button :label="2">我的</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="查询选择">
          <el-radio-group v-model="item.formType">
            <el-radio-button :label="1">通常表单</el-radio-button>
            <el-radio-button :label="2">快捷查询</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="快捷查询" v-show="item.formType == '2'">
          <el-radio-group v-model="item.fastQuery">
            <el-radio :label="1">今日上报</el-radio>
            <el-radio :label="2">今日整改</el-radio>
            <el-radio :label="3">一周内未整改</el-radio>
            <el-radio :label="4">未整改</el-radio>
            <el-radio :label="5">未闭合</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="行为" v-show="item.formType == '1'">
          <el-select v-model="item.behavior" style="width:100%;">
            <el-option
              v-for="(behavior, index) in behaviorList"
              :key="index"
              :label="behavior"
              :value="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="隐患种类">
          <el-select
            v-model="item.c_catalog"
            placeholder="选择隐患种类(不选默认查询所有)"
            style="width:100%;"
            clearable
          >
            <el-option
              v-for="(catalog, index) in catalogList"
              :key="index"
              :label="catalog"
              :value="catalog"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" v-show="item.formType == '1'">
          <el-select
            v-model="item.c_status"
            placeholder="选择状态(不选默认查询所有)"
            style="width:100%;"
            clearable
          >
            <el-option
              v-for="(status, index) in statusList"
              :key="index"
              :label="status"
              :value="status"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="时间范围" v-show="item.formType == '1'">
          <el-date-picker
            v-model="tempDateTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%;"
            clearable
            @change="setStartTimeAndEndTime"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <div style="text-align:right;">
        <el-button @click="clearForm">清空</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 模糊查询框 -->
    <el-form action="/">
      <el-input placeholder="请输入名称关键词" prefix-icon="el-icon-search" v-model="searchCtx">
        <el-button slot="append" icon="el-icon-search" @click="searchProject"></el-button>
      </el-input>
    </el-form>

    <!-- 列表区域 -->

    <div>
      <!----------------------------------edit by cyt 2020.6.9----------------------------------------------->
      <!-- <el-row>
        <el-col :md="12" :sm="24" v-for="(item,c_id) in list" :key="c_id" :index="c_id">
          
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <div><span ><font font-size="14px" color="#606266"><b>{{item.id}}(
                <span v-if="item.c_status_format == '未整改'" style="color:#179a16">{{item.c_status_format}}</span>
                 <span v-if="item.c_status_format == '已整改'" style="color:#FFA133">{{item.c_status_format}}</span>
                  <span v-if="item.c_status_format == '已闭合'" style="color:#908888">{{item.c_status_format}}</span>
                ):</b></font></span></div>
              <div style="margin-top: 4px; font-size: 11px;">发布时间: {{item.c_when_format}}</div>
            </div>

            <div style="color: #969799;font-size: 0.9rem">隐患类型：<span style=" font-size: 11px; color:#606266;">{{item.catalog_name}}</span></div>
            <div

              style="font-size: 0.9rem; float:right; position: relative"
            >{{item.group_name}}: {{item.c_who_real_name}}</div>
         
            <div style="color: #969799;font-size: 0.9rem">隐患部位：<span style=" font-size: 11px; color:#606266;">{{$util.cutStr(item.c_where,50)}}</span></div>
            <div style="color: #969799;font-size: 0.9rem">隐患描述：<span style=" font-size: 11px; color:#606266;">{{$util.cutStr(item.c_what,50)}}</span></div>
            <div style="color: #969799;font-size: 0.9rem;">整改要求：<span style=" font-size: 11px; color:#606266;">{{$util.cutStr(item.c_how,50)}}</span></div>
            <div style="float:right;">
              <el-button type="text" @click="showDetail(item.id)">详情</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>-->
      <el-table
        :data="list"
        style="width: 100%;"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
      >
        <el-table-column label="安全违章表">
          <el-table-column label="隐患名称">
            <template slot-scope="scope">
              <span>{{scope.row.c_name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="隐患类型">
            <template slot-scope="scope">
              <span>{{scope.row.catalog_name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="整改要求">
            <template slot-scope="scope">
              <span>{{$util.cutStr(scope.row.c_how,50)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="告警级别">
            <template slot-scope="scope">
              <span>{{$util.cutStr(scope.row.c_level)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="整改进度">
            <template slot-scope="scope">
              <span
                v-if="scope.row.c_status_format == '未整改'"
                style="color:#179a16"
              >{{scope.row.c_status_format}}</span>
              <span
                v-if="scope.row.c_status_format == '已整改'"
                style="color:#FFA133"
              >{{scope.row.c_status_format}}</span>
              <span
                v-if="scope.row.c_status_format == '已闭合'"
                style="color:#908888"
              >{{scope.row.c_status_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="整改期限">
            <template slot-scope="scope">
              <span>{{scope.row.c_deadline}}</span>
            </template>
          </el-table-column>
          <el-table-column label="上传人">
            <template slot-scope="scope">
              <span>{{scope.row.c_who_real_name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间">
            <template slot-scope="scope">
              <span>{{scope.row.c_when_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="隐患描述">
            <template slot-scope="scope">
              <span>{{$util.cutStr(scope.row.c_what,50)}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{scope.row.id}}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="隐患部位">
            <template slot-scope="scope">
              <span>{{$util.cutStr(scope.row.c_where,50)}}</span>
            </template>
          </el-table-column>
          
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button icon="el-icon-view" size="small" @click="showDetail(scope.row.id)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <!--------------------------------------------end-------------------------------------------------------->
    </div>

    <!----------------------------------------zf------------------------------------------------>
    <!-- 弹窗1 -->
    <el-dialog
      :visible.sync="dialogVisible_1"
      :title="dialogType==='edit'?'编辑违章':'新建违章'"
      width="80%"
    >
      <el-form :model="input" label-position="left" ref="dataForm" class="demo-ruleForm">
        <el-form-item label>
          <span style="color:red">*</span> 隐患名称:
          <el-input v-model="input.c_name" placeholder="输入隐患名称"></el-input>
        </el-form-item>
        <el-form-item label>
          <span style="color:red">*</span> 选择隐患类别:
          <el-select
            class="item-choose"
            v-model="input.issuesTypes"
            @change="selectStorage"
            style="width:100%"
          >
            <el-option
              v-for="item in cataloginfoList"
              :key="item.c_id"
              :label="item.c_name"
              :value="item.c_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="c_desc">
          <span style="color:red">*</span>
          <el-button type="primary" size="small" plain @click="isShow.shiGongPopup = true">选择接收人</el-button>

          <el-input readonly v-model="input.shiGongNames" @click="isShow.shiGongPopup = true"></el-input>
        </el-form-item> -->

        <el-form-item label>
          <span style="color:red">*</span> 选择接收人:
          <el-cascader
            placeholder="选择接收人"
            :options="receiverOptions"
            clearable
            :show-all-levels="false"
            :props="{ multiple: true }"
            ref="cascader"
            v-model="tempReceiverSelected"
            style="width: 100%;"
          ></el-cascader>
        </el-form-item>

        <el-form-item label>
          <span style="color:red">*</span> 告警级别:
          <el-select
            class="item-choose"
            v-model="input.alarmLevel"
            @change="selectStorage"
            style="width:100%"
          >
            <el-option
              v-for="item in alarmLevel"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="总共人数:">
          <el-input v-model.number="input.humenC" placeholder="0" />
        </el-form-item>

        <el-form-item label>
          <span style="color:red">*</span>
          整改期限:
          <!-- @click="changeTerm" -->
          <el-radio-group
            v-model="radio3"
            style="position: relative; left: 10%"
            size="small"
            @change="changeTerm"
          >
            <el-radio-button label="立即"></el-radio-button>
            <el-radio-button label="3天"></el-radio-button>
            <el-radio-button label="7天"></el-radio-button>
            <el-radio-button label="停工整改"></el-radio-button>
            <el-radio-button label="其他天数"></el-radio-button>
          </el-radio-group>
          <el-input
            v-show="other"
            v-model.number="input.term"
            auto-complete="off"
            placeholder="输入其他天数"
          />
        </el-form-item>
        <el-form-item label>
          <span style="color:red">*</span> 隐患部位:
          <el-input v-model="input.inputWhere" auto-complete="off" placeholder="输入隐患部位" />
          <br />
        </el-form-item>
        <!-- <el-form-item label>
          <el-select
            class="item-choose"
            v-model="input.where"
            @change="selectStorage"
            style="width:100%"
            placeholder="选择隐患部位"
          >
            <el-option
              v-for="item in whereInfoList"
              :key="item.id"
              :label="item.c_where"
              :value="item.c_where"
            ></el-option>
          </el-select>
        </el-form-item>-->

        <el-form-item label>
          <span style="color:red">*</span> 选择责任单位:
          <el-select
            class="item-choose"
            v-model="input.group"
            @change="selectStorage1"
            style="width:100%"
          >
            <el-option
              v-for="item in groupInfoList"
              :key="item.c_id"
              :label="item.c_name"
              :value="item.c_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label>
          <span style="color:red">*</span> 隐患描述:
          <br />
          <el-input v-model="input.desc" placeholder="隐患描述" />
        </el-form-item>

        <el-form-item prop="c_desc">
          <span style="color:red">*</span>整改要求:
          <el-input v-model="input.changes" placeholder="整改要求" />
        </el-form-item>
        <!-- accept=".jpg, .jpeg, .png, .gif, .bmp, .pdf, .JPG, .JPEG, .PBG, .GIF, .BMP, .PDF" -->
        <!-- <el-upload
             name="multipartfiles"
      class="upload-demo"
      ref="upload"
      :limit="10"
      :action="doUpload"
      :file-list="fileList"
      :on-remove="handleRemove"
      :on-change="handleChange"
      :on-success="handleSuccess"
      :on-error="handleError"
      :data="input"
      multiple
      :auto-upload="false"
      :with-credentials="true"
    > <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            添加附件：
            <em>点击上传</em>
          </div>
        </el-upload>-->
        <el-upload
          name="multipartfiles"
          class="upload-file"
          style="border:solid #eeeeee;text-align: center;"
          ref="upload"
          :action="doUpload"
          :data="input"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :on-success="returnData"
          :on-error="handleError"
          accept=".jpg, .jpeg, .png, .gif, .bmp, .pdf, .JPG, .JPEG, .PBG, .GIF, .BMP, .PDF"
          :with-credentials="true"
          :auto-upload="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            添加附件：
            <em>点击上传</em>
          </div>
        </el-upload>
      </el-form>
      <div style="text-align:right;">
        <el-button type="primary" @click="confirmRole('dataForm')">确认</el-button>
      </div>
    </el-dialog>
    <!------------------------------------- zf ------------------------------------------->
    <!------------------------------------- zf ------------------------------------------->
    <div>
      <el-dialog title="接收人选择" :visible.sync="isShow.shiGongPopup" width="90%" :show-close="false">
        <el-tree
          ref="shiGongTree"
          node-key="userId"
          style="position:relative;z-index:0"
          :data="groupData.shiGong"
          :props="groupProps"
          :check-strictly="true"
          show-checkbox
          @check-change="handleCheckChangeShiGong"
        ></el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeShiGongDialog(0)">取 消</el-button>
          <el-button type="primary" @click="closeShiGongDialog(1)">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!------------------------------------- zf ------------------------------------------->
    <div class="pagination">
      <el-pagination
        style="text-align:center;"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30]"
        :page-size="itemsPerPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import TZApi from "@/api/tz";
import G from "@/views/common/global";
import ZFApi from "@/api/zf";
import {
  Grid,
  GridItem,
  Pagination,
  Search,
  Dialog,
  Field,
  Picker,
  Toast
} from "vant";

export default {
  components: {
    Pagination,
    Search
  },
  data() {
    return {
      rules: {
        key: [
          { required: true, message: "key is required", trigger: "change" }
        ],
        name: [
          { required: true, message: "name is required", trigger: "change" }
        ]
      },
      windowSize: this.$util.getWindowSize(),
      query: {
        id: "",
        page: 1,
        pageSize: 10,
        pageNumber: 1
      },
      /* tz new */
      userId: "",
      list: [],
      catalogList: [],
      behaviorList: ["所有", "上报", "整改", "闭合", "关注", "评论"],
      statusList: ["未整改", "已整改", "已闭合"],
      count: 0,
      page: 1,
      itemsPerPage: 10,
      //----------------------------zf-------------------------------//
      fileList: [],
      hooseFile: false,
      dialogType: "add",
      groupList: [],
      other: false,
      groupInfoList: "",
      dialogVisible_1: false,
      uploadData: {},
      doUpload:
        G.BASE_URL +
        "/zf/reportSlovingWithFile?access_token=" +
        sessionStorage.getItem("token"),
      files: [],
      groupData: {
        shiGong: []
      },
      groupProps: {
        children: "childrenGroup",
        label: "name",
        disabled: "disabled"
      },
      reportData: {
        stage: 0, //  表示为工程上报
        reportItemId: "",
        reportUser: "",
        checkList: [],
        shiGongInfo: "",
        kanChaInfo: "",
        sheJiInfo: "",
        jianLiInfo: "",
        jianSheInfo: "",
        desc: ""
      },
      radio3: "立即",
      cataloginfoList: "",
      whereInfoList: "",
      input: {},
      isShow: {
        shiGong: false,
        kanCha: false,
        sheJi: false,
        jianLi: false,
        jianShe: false,
        shiGongPopup: false,
        kanChaPopup: false,
        sheJiPopup: false,
        jianLiPopup: false,
        jianShePopup: false
      },
      //----------------------------zf-------------------------------//
      startTime: "",
      endTime: "",
      item: {
        belong: 1,
        formType: 1,
        fastQuery: 1,
        behavior: 0,
        c_catalog: null,
        c_status: null,
        startTime: null,
        endTime: null
      },
      newData: {},
      file: [],
      searchCtx: "",
      showQueryDialog: false,
      tempDateTimeRange: [],
      receiverOptions: [],
      tempReceiverSelected: [],
      //add by lcc 2021-7-28 start
      alarmLevel: [{value:1,name:1},{value:2,name:2},{value:3,name:3},{value:4,name:4},{value:5,name:5},{value:6,name:6},{value:7,name:7}],
      ifCheck: true,
      checkC_id: ''
      //add by lcc 2021-7-28 end
    };
  },
  mounted() {
    this.userId =
      this.$store.getters.c_id != undefined ? this.$store.getters.c_id : "";
    this.projectId = JSON.parse(sessionStorage.project).c_id;
    //----------------------------------------------zf---------------------------------------//
    this.checkC_id = this.$route.query.c_id
    this.getIssuesTypeList();
    this.listGroupInfo();
    this.getWhereInfoList();
    this.getGroupList();
    TZApi.getReceiversOptions().then(response => {
      this.receiverOptions = response.data.receiverOptions;
    });
    this.uploadData = {
      meet_id: this.meet_id
    };
    this.doUpload =
      G.BASE_URL +
      "/zf/reportSlovingWithFile?access_token=" +
      sessionStorage.getItem("token");

    if (this.radio3 == "其他天数") {
      this.other = true;
    }

    //----------------------------------------------zf---------------------------------------//
    let data = {}
    if(this.checkC_id != undefined){
        this.ifCheck = false,
        data = {
        c_id: this.checkC_id,
        projectId: this.projectId,
        userId: this.userId,
        searchCtx: this.searchCtx,
        item: this.item,
        page: this.page,
        itemsPerPage: this.itemsPerPage,
      };
    }else{
      this.ifCheck = true,
      data = {
      projectId: this.projectId,
      userId: this.userId,
      searchCtx: this.searchCtx,
      item: this.item,
      page: this.page,
      itemsPerPage: this.itemsPerPage
    };
    }
    this.getSBYH(data);
    this.selectGr();
    TZApi.getCatalog().then(response => {
      this.catalogList = response.data.catalogList;
      //   console.log(this.catalogList);
    });
  },
  methods: {
    //------------------------------------------zf--------------------------------------------------//
    httpRequest(param) {
      this.file.push(param.file); // 一般情况下是在这里创建FormData对象，但我们需要上传多个文件，为避免发送多次请求，因此在这里只进行文件的获取，param可以拿到文件上传的所有信息
    },

    selectGr() {
      ZFApi.getGroupByUserid(this.userId).then(response => {
        // console.log("+++");
        // console.log(response.data);
        this.input.group = response.data * 1;
        //   console.log(this.catalogList);
      });
    },
    //上报提交
    confirmRole() {
      if (this.input.issuesTypes == undefined) {
        // alert(this.input.issuesTypes)
        // Toast.fail("选择隐患类型");
        this.$message({
          type: "warning",
          message: "选择隐患类型!"
        });
        return;
      }

      if (this.tempReceiverSelected.length == 0) {
        // Toast.fail("");
        this.$message({
          type: "warning",
          message: "请选择接收人!"
        });
        return;
      }
      if (this.input.inputWhere == undefined && this.input.where == undefined) {
        //Toast.fail("请选择隐患部位");
        this.$message({
          type: "warning",
          message: "请选择隐患部位!"
        });
        return;
      }

      if (this.input.group == undefined) {
        //Toast.fail("请输入责任单位");
        this.$message({
          type: "warning",
          message: "请输入责任单位!"
        });
        return;
      }

      if (this.input.desc == undefined) {
        //Toast.fail("请输入隐患描述");
        this.$message({
          type: "warning",
          message: "请输入隐患描述!"
        });
        return;
      }

      if (this.input.changes == undefined) {
        //Toast.fail("请输入整改要求");
        this.$message({
          type: "warning",
          message: "请输入整改要求!"
        });
        return;
      }

      //this.onlyOne=true 表示最后一人审批时
      // this.input.issuesTypes
      this.input.radio3 = this.radio3;
      this.input.userId = this.$store.getters.c_id;
      this.input.projectId = JSON.parse(sessionStorage.project).c_id;

      let temp = "";
      this.tempReceiverSelected.forEach(element => {
        temp += element[element.length-1] + "|";
      });
      // console.log(temp);
      this.input.shigongIds = temp;
      this.tempReceiverSelected = [];

      console.log("this.input");
      console.log(this.input);
      console.log(this.chooseFile);
      if (!this.chooseFile) {
        ZFApi.rereportYHSB(this.input).then(res => {
          let result = res;
          console.log(result);
          if (result.code == "200") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            //location.reload();
            //this.$router.push("/mobile/user/blog/followup/" + this.clevel);

            this.defaultProject = "";
            this.defaultGroup = "";
            this.defaultUser = "";
            this.dialogVisible_1 = false;
            let data = {
              c_id: this.checkC_id,
              projectId: this.projectId,
              userId: this.userId,
              searchCtx: this.searchCtx,
              item: this.item,
              page: this.page,
              itemsPerPage: this.itemsPerPage
            };
            this.getSBYH(data);
          } else {
            this.$message({
              type: "warning",
              message: "操作失败"
            });
          }
        });
      } else {
        console.log("上传文件");

        this.$refs.upload.submit();
        this.dialogVisible_1 = false;
        this.defaultProject = "";
        this.defaultItem = "";
        this.defaultGroup = "";
        this.defaultUser = "";
        location.reload();
        let data = {
          c_id: this.checkC_id,
          projectId: this.projectId,
          userId: this.userId,
          searchCtx: this.searchCtx,
          item: this.item,
          page: this.page,
          itemsPerPage: this.itemsPerPage
        };
        this.getSBYH(data);
      }
    },

    handleRemove(file, fileList) {
      this.chooseFile = false;
    },
    handleChange(file, fileList) {
      this.chooseFile = true;
    },
    handleSuccess(response, file, fileList) {
      Toast.success("上报成功");
    },
    handleError(err, file, fileList) {
      Toast.fail("文件上传失败");
    },

    changeTerm() {
      //  alert(this.radio3);
      if (this.radio3 == "其他天数") {
        this.other = true;
      } else {
        this.other = false;
      }
      // this.input.term =   this.radio3
    },

    listGroupInfo() {
      ZFApi.getGroup1().then(response => {
        let result = response.data;
        // console.log("result");
        // console.log(result);

        this.groupData.shiGong = result;
        // console.log("发送人");
        // console.log(this.groupData.shiGong);
        sessionStorage.setItem(
          "groupData",
          JSON.stringify(this.groupData.shiGong)
        );
      });
    },
    getIssuesTypeList() {
      ZFApi.getCatalogList().then(response => {
        this.$toast.clear();
        // console.log(response.data);
        this.cataloginfoList = response.data;
      });
    },

    getWhereInfoList() {
      ZFApi.getWhereInfoList().then(response => {
        this.$toast.clear();
        // console.log("getWhereInfoList");
        // console.log(response.data);
        this.whereInfoList = response.data;
      });
    },

    getGroupList() {
      ZFApi.groupList().then(response => {
        this.$toast.clear();
        // console.log("getGroupList");
        // console.log(response.data);
        this.groupInfoList = response.data;
      });
    },

    handleCheckChangeShiGong(data, checked, indeterminate) {},
    // 施工对话框
    closeShiGongDialog(e) {
      if (e == 0) {
        //  取消
      } else {
        //  确定
        let nodes = this.$refs.shiGongTree.getCheckedNodes();
        this.input.shiGongNames = "";
        this.input.shigongIds = "";
        this.input.shiGongNamecount = nodes.length;
        this.input.humenC = nodes.length;
        let obj = "";
        for (let j = 0, len = nodes.length; j < len; j++) {
          if (nodes[j].name != undefined) {
            this.input.shiGongNames += "" + nodes[j].name;
            this.input.shigongIds += nodes[j].userId + "|";
            //  console.log("nodes["+j+"].name");
            // console.log(nodes[j]);
            // element文件上传比较low，直接push成数组，后端获取不到数据
            //  在这里只能拼接成字符串格式，后端再转换成json，并不是我比较蠢
            obj +=
              "{ 'shiGongMobile':" +
              nodes[j].mobile +
              "," +
              "'shiGongGroup':" +
              nodes[j].id +
              "},";
          }
        }
        this.reportData.shiGongInfo = "[" + obj + "]";
      }
      this.isShow.shiGongPopup = false;
    },
    // 选择Gorup
    selectStorage(e) {
      // this.role.storageCode = e;
      // this.role.materialNameList ="";
    },
    // 选择Gorup
    selectStorage1(e) {
      this.$forceUpdate();
      // this.role.storageCode = e;
      // this.role.materialNameList ="";
      console.log("e1");
      console.log(e);
      this.input.group = e * 1;
    },

    returnData(response, file, fileList) {
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.imgUrl = this.imgUrl + "," + response.data;
    },
    failData() {
      this.$message({
        message: "操作失败",
        type: "error"
      });
    },
    handleAddRole() {
      this.dialogVisible_1 = true;
    },
    //------------------------------------------zf--------------------------------------------------//
    setStartTimeAndEndTime() {
      this.item.startTime = this.tempDateTimeRange[0];
      this.item.endTime = this.tempDateTimeRange[1];
    },
    getSBYH(data) {
      const loading = this.$loading({
        lock: true,
        text: "列表加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      TZApi.getSBYH(data).then(response => {
        loading.close();
        this.list = response.data.list;
        this.count = response.data.count;
        console.log(this.count);
      });
    },
    clearForm() {
      this.item = {
        belong: 1,
        formType: 1,
        fastQuery: 1,
        behavior: 0,
        c_catalog: null,
        c_status: null,
        startTime: null,
        endTime: null
      };
      this.tempDateTimeRange = [];
    },
    submit() {
      console.log(this.item);
      this.page = 1;
      let data = {
        c_id: this.checkC_id,
        projectId: this.projectId,
        userId: this.userId,
        searchCtx: this.searchCtx,
        item: this.item,
        page: this.page,
        itemsPerPage: this.itemsPerPage
      };
      // console.log(data);
      this.getSBYH(data);
      this.showQueryDialog = false;
    },
    handleCurrentChange(page) {
      this.page = page;
      let data = {
        c_id: this.checkC_id,
        projectId: this.projectId,
        userId: this.userId,
        searchCtx: this.searchCtx,
        item: this.item,
        page: this.page,
        itemsPerPage: this.itemsPerPage
      };
      this.getSBYH(data);
    },
    handleSizeChange(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.page = 1;
      let data = {
        c_id: this.checkC_id,
        projectId: this.projectId,
        userId: this.userId,
        searchCtx: this.searchCtx,
        item: this.item,
        page: this.page,
        itemsPerPage: this.itemsPerPage
      };
      this.getSBYH(data);
    },
    searchProject() {
      console.log(this.searchCtx);
      this.page = 1;
      let data = {
        c_id: this.checkC_id,
        projectId: this.projectId,
        userId: this.userId,
        searchCtx: this.searchCtx,
        item: this.item,
        page: this.page,
        itemsPerPage: this.itemsPerPage
      };
      this.getSBYH(data);
    },
    showDetail(value) {
      // console.log(value);
      this.$router.push("/other/vorDetail/" + value);
    }
  }
};
</script>
<style lang="less">
.el-card__body {
  position: relative;
  left: 12px;
}
</style>
    


// WEBPACK FOOTER //
// src/views/safety/vor.vue